import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
export var StartupError = function () {
    var t = useTranslation().t;
    return (_jsx(Alert, { className: "startup-error", severity: "error", action: _jsx(Button, { className: "startup-retry", onClick: function () { return window.location.reload(); }, children: t("startup.retry") }), children: t("startup.error") }));
};
